<template>
  <div>
    <strong>{{ item?.text || '-' }}</strong>
    <div class="row-actions break-normal">
      <span v-for="(action, key, index) in item.actions" :key="index" :class="[action.id.replace('.', '-'), action.style || '']">
        <a href="#" :aria-label="action.label" @click.prevent="handleAction(item, action)">
          {{ action.label }}
        </a>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      events: []
    }
  },
  computed: {
    row() {
      let row = this.config?.row
      if (_.isObjectLike(row)) {
        return row
      }
      return {}
    },
    item() {
      return this.row[this.config?.key] || {}
    }
  },
  props: {
    config: Object
  },
  methods: {
    handleAction(item, action) {
      if (action.type == 'modal') {
        this.$emitter.emit('Modal', {
          name: action.id,
          $el: this.$el instanceof HTMLElement ? this.$el.closest('tr.item') : this.$el.parentNode.closest('tr.item'),
          data: this.row,
          item: item
        })
      } else if (action.type == 'action') {
        this.$emitter.on(`action.${action.id}`, this.listenAction, 100)
        this.$emitter.emit(`action.${action.id}`, {
          $el: this.$el instanceof HTMLElement ? this.$el.closest('tr.item') : this.$el.parentNode.closest('tr.item'),
          data: this.row,
          item: item,
          action
        })
      } else if (action.type == 'href') {
        window.open(action.id, '_blank').focus()
      }
    },
    listenAction({ action, $el }) {
      this.$emitter.off(`action.${action.id}`, this.listenAction)
      if (action.confirm && !window.confirm('Are you sure?')) {
        return null
      }
      if (!action.uri || !action.method) {
        return null
      }
      this.$util.request(
        action.uri,
        {},
        $el,
        {
          done: () => {
            this.$emitter.emit('TableList.Refresh')
          }
        },
        {
          method: action.method || 'get'
        }
      )
    }
  }
}
</script>
<style lang="scss">
.table-container {
  .table-list {
    .row-actions break-normal {
      .span {
        color: #3f6ad8;
      }
      a {
        color: inherit;
      }
    }
  }
}
</style>
